/** Web → native */
export const NATIVE_BRIDGE_OUTBOUND = {
  /** Store email + password in device Keychain/Keystore (after successful login). */
  SAVE_LOGIN_CREDENTIALS: "SAVE_LOGIN_CREDENTIALS",
  /** Read saved credentials; response echoes `requestId`. */
  LOAD_LOGIN_CREDENTIALS: "LOAD_LOGIN_CREDENTIALS",
  /** Clear keychain entry (e.g. explicit sign-out). */
  CLEAR_LOGIN_CREDENTIALS: "CLEAR_LOGIN_CREDENTIALS",
};

/** Native → web */
export const NATIVE_BRIDGE_INBOUND = {
  LOGIN_CREDENTIALS_LOADED: "LOGIN_CREDENTIALS_LOADED",
  LOGIN_CREDENTIALS_ERROR: "LOGIN_CREDENTIALS_ERROR",
  LOGIN_CREDENTIALS_SAVED: "LOGIN_CREDENTIALS_SAVED",
  LOGIN_CREDENTIALS_CLEARED: "LOGIN_CREDENTIALS_CLEARED",
};
